import { jsx as _jsx } from "react/jsx-runtime";
const Bullet = ({ className = '' }) => (_jsx("div", { className: `inline-block min-h-1 min-w-1 rounded-full bg-text ${className} mr-2` }));
export default Bullet;
